import React from 'react';
import StarField from './StarField';

const FeaturedVideoSection = () => {
  const videoId = 'Ub3yyfwl1jI';

  return (
    <section className="py-24 bg-black relative overflow-hidden">
      <StarField density="sparse" />
      <div className="container mx-auto px-6 max-w-5xl relative z-10">
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-4 tracking-tight">
            Featured Video
          </h2>
          <div className="w-20 h-1 bg-white mx-auto"></div>
        </div>

        <div className="relative w-full overflow-hidden bg-white/5 border border-white/10" style={{ paddingBottom: '56.25%' }}>
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1`}
            title="Featured video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default FeaturedVideoSection;
